import HubSession from '@/server-events/HubSession';
import { ProjectTaskOverview, ProjectChangeRequestOverview } from '@/state/seller/project-overview/reducer';
import { getCMConnectionManager } from './connections';

type ProjectTaskOverviewReceiveHandler = (landingPage: ProjectTaskOverview) => void;
type ProjectChangeRequestOverviewReceiveHandler = (landingPage: ProjectChangeRequestOverview) => void;

type EventHandler = ProjectTaskOverviewReceiveHandler | ProjectChangeRequestOverviewReceiveHandler;

export class SellerSession extends HubSession {
    private _profileId: number;
    private _projectId: number;

    constructor(profileId: number, projectId: number) {
        super(getCMConnectionManager());
        this._profileId = profileId;
        this._projectId = projectId;

        this.join();
    }

    onReconnect() {
        this.join();
    }

    join() {
        return this.connection.invoke('JoinSeller', this._profileId, this._projectId);
    }

    protected addHandler(
        method: 'ReceiveProjectChangeRequestOverview',
        handler: ProjectChangeRequestOverviewReceiveHandler
    ): void;
    protected addHandler(method: 'ReceiveProjectTaskOverview', handler: ProjectTaskOverviewReceiveHandler): void;
    protected addHandler(method: string, handler: EventHandler): void {
        super.addHandler(method, handler);
    }

    addProjectTaskOverviewReceiveHandler(handler: ProjectTaskOverviewReceiveHandler) {
        this.addHandler('ReceiveProjectTaskOverview', (projectOverview) => {
            handler(projectOverview);
        });
    }

    addProjectChangeRequestOverviewReceiveHandler(handler: ProjectChangeRequestOverviewReceiveHandler) {
        this.addHandler('ReceiveProjectChangeRequestOverview', (projectOverview) => {
            handler(projectOverview);
        });
    }
}